module.exports = __webpack_public_path__ + "img/tarj1-4.2fae0f02.png";